import React, { useEffect, useMemo, useState } from 'react';
import './Home.css';
import api from '../api/axiosConfig';
import {
  Calendar,
  Bell,
  AlertCircle,
  Wallet,
  TrendingUp,
  TrendingDown,
  Minus,
  ChevronDown,
  PieChart,
  Megaphone
} from 'lucide-react';

function Home() {
  const [totalData, setTotalData] = useState({});
  const [remainData, setRemainData] = useState([]);
  const [remainData2, setRemainData2] = useState([]);
  const [showAllNotices, setShowAll] = useState(false);

  // 1. 누적금액 조회
  useEffect(() => {
    api.get('/api/Home/searchList')
      .then((res) => setTotalData(res.data?.[0] ?? {}))
      .catch((err) => console.error('누적금액 조회 오류:', err));
  }, []);

  // 2. 미결금 조회
  useEffect(() => {
    api.get('/api/Home/remainList')
      .then((res) => setRemainData(res.data || []))
      .catch((err) => console.error('미수금 조회 오류:', err));
  }, []);

  // 3. 잔금 조회
  useEffect(() => {
    api.get('/api/Home/remainList2')
      .then((res) => setRemainData2(res.data || []))
      .catch((err) => console.error('잔금 조회 오류:', err));
  }, []);

  // ── 날짜 유틸 ──────────────────────────────────────────────
  const getDayName = () => {
    const days = ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'];
    return days[new Date().getDay()];
  };

  const getQuarterLabel = () => {
    const m = new Date().getMonth();
    return `Q${m < 3 ? 1 : m < 6 ? 2 : m < 9 ? 3 : 4}`;
  };

  const getDayOfYear = () => {
    const today = new Date();
    const start = new Date(today.getFullYear(), 0, 0);
    return Math.floor((today - start) / (1000 * 60 * 60 * 24));
  };

  const getProgressRates = () => {
    const today = new Date();
    const year = today.getFullYear();

    const monthStart = new Date(year, today.getMonth(), 1);
    const monthEnd = new Date(year, today.getMonth() + 1, 0);
    const monthProgress = Math.round(((today - monthStart) / (monthEnd - monthStart)) * 100);

    return { monthProgress };
  };

  // ── 포맷 유틸 ──────────────────────────────────────────────
  const formatNumber = (num) => {
    if (num === null || num === undefined) return '0';
    const n = parseFloat(num.toString().replace(/,/g, ''));
    return isNaN(n) ? '0' : n.toLocaleString('ko-KR', { maximumFractionDigits: 0 });
  };

  const isNewNotice = (dateString) => {
    const diff = new Date().getTime() - new Date(dateString).getTime();
    return Math.ceil(diff / (1000 * 60 * 60 * 24)) <= 7;
  };

  // ── 날짜 계산 ──────────────────────────────────────────────
  const today = new Date();
  const dayName = useMemo(() => getDayName(), []);
  const quarterLabel = useMemo(() => getQuarterLabel(), []);
  const dayOfYear = useMemo(() => getDayOfYear(), []);
  const { monthProgress } = useMemo(() => getProgressRates(), []);

  const daysLeft = useMemo(() => {
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    return lastDay.getDate() - today.getDate();
  }, [today]);

  const todayFormatted = today.toISOString().split('T')[0];

  // ── KPI ───────────────────────────────────────────────────
  const outData = totalData.OUT_DATA || 0;
  const inData = totalData.IN_DATA || 0;
  const profit = outData - inData;
  const profitRate = outData > 0 ? Math.round((profit / outData) * 100) : 0;

  // ── 미결금 / 잔금 합계 ─────────────────────────────────────
  const remainTotal = useMemo(
    () => remainData.reduce((s, r) => s + (parseFloat(r.REMAIN_AMOUNT) || 0), 0),
    [remainData]
  );
  const remainTotal2 = useMemo(
    () => remainData2.reduce((s, r) => s + (parseFloat(r.REMAIN_AMOUNT) || 0), 0),
    [remainData2]
  );

  // ── 공지사항 데이터 ────────────────────────────────────────
  const noticeData = [
  {
          date: '2026-09-03', version: 'v1.2.2', title: '기능 개선',
          details: ['매출매입 등록 시 기타경비의 경우 부가세가 자동으로 0원 처리됩니다.', '조회 화면의 소계, 총계, 합계 행의 배경색이 연하게 변경되었습니다.'],
        },
      {
        date: '2026-07-20', version: 'v1.2.1', title: '기능 개선',
        details: ['현장 노트 페이지가 추가되었습니다.', '홈 화면 디자인이 변경되었습니다.', '모바일 접속 시 화면 가독성이 개선되었습니다.'],
      },
    {
      date: '2026-06-22', version: 'v1.2.0', title: '기능 개선',
      details: ['매입매출 화면에서 행 추가 시 조회조건에 선택한 현장이 자동 선택됩니다.', '매입매출 화면 행 고정 오류가 수정되었습니다.', '홈 화면 레이아웃이 변경되었습니다.'],
    },
    {
      date: '2026-06-05', version: 'v1.1.9', title: '기능 개선',
      details: ['총괄정산서 페이지에 비고 저장 기능이 추가되었습니다.', '수금현황 페이지에 기준일, 현장 조회 기능이 추가되었습니다.'],
    },
        {
          date: '2026-05-30', version: 'v1.1.8', title: '매출정산서 업데이트',
          details: ['매출정산서 페이지에 비고 항목이 추가되었습니다.'],
        },
        {
          date: '2026-05-13', version: 'v1.1.7', title: '수금현황 페이지 추가',
          details: ['수금현황 페이지가 추가되었습니다.'],
        },
        {
          date: '2026-03-23', version: 'v1.1.6', title: '기능 개선',
          details: ['매입매출 등록 화면에 등록일 조회 기능이 추가되었습니다.'],
        },
        {
          date: '2026-03-18', version: 'v1.1.5', title: '기능 개선',
          details: [
            '총괄정산서 페이지가 추가되었습니다.',
            '현장등록 페이지에 현장대리인, 공사시작일, 공사종료일 컬럼이 추가되었습니다.',
          ],
        },
        {
          date: '2026-03-12', version: 'v1.1.4', title: '기능 개선 및 오류 수정',
          details: [
            '메모 기능이 추가되었습니다.',
            '그리드 테마가 엑셀 느낌의 테마로 변경되었습니다.',
            '기간별 조회 화면에서 출력 시 자재대/장비대 컬럼은 숨기고 출력됩니다.',
            '거래처 등록 시 거래처명이 기본 예금주값으로 입력됩니다.',
            '매출매입 등록 시 결제일자를 선택하면 결제금액이 자동입력 됩니다.',
          ],
        },
        {
          date: '2026-02-22', version: 'v1.1.3', title: '기능 개선 및 오류 수정',
          details: [
            '매입매출 등록 화면에 거래처 등록 기능이 추가되었습니다.',
            '이제 기타경비의 동일 항목은 금액이 합산되어 표시됩니다.',
            '매출정산서 페이지가 추가되었습니다.',
          ],
        },
        {
          date: '2026-02-08', version: 'v1.1.2', title: '기능 개선 및 오류 수정',
          details: [
            '거래처등록 화면에서 Tab키로 이동 시 입력한 데이터가 사라지는 문제가 수정되었습니다.',
            '매입매출 등록 화면에 열 고정 기능이 추가되었습니다.',
            '비고 칸의 데이터가 일정 길이 이상인 경우 자동 줄바꿈이 추가되었습니다.',
          ],
        },
        {
          date: '2026-02-04', version: 'v1.1.1', title: '기능 개선',
          details: [
            '거래처등록 화면에서 매입매출, 구분, 기타경비 여부를 추가할 수 있습니다.',
            '매출/매입 등록 화면에서 거래처 선택 시 위의 내용이 자동 적용됩니다.',
            '현장 등록, 거래처 등록 화면의 정렬이 가나다순 → 최신등록순으로 변경되었습니다.',
          ],
        },
        {
          date: '2026-01-31', version: 'v1.1.0', title: '기능 개선',
          details: [
            '매입매출 화면의 상단스크롤이 추가되었습니다.',
            '그리드의 너비 및 높이가 개선되었습니다.',
          ],
        },
        {
          date: '2026-01-29', version: 'v1.0.9', title: '오류 수정 및 기능 개선',
          details: [
            '현장별 매출매입 조회 오류가 수정되었습니다.',
            '현장등록, 거래처등록 화면의 한글 입력 오류가 수정되었습니다.',
          ],
        },
        {
          date: '2026-01-25', version: 'v1.0.8', title: '저장 오류 수정',
          details: ['저장 오류가 수정되었습니다.', '이제 HTTPS 접속이 가능합니다.'],
        },
        {
          date: '2025-12-07', version: 'v1.0.7', title: '조회기능 업데이트',
          details: ['등록 화면에서 거래처별 조회가 가능합니다.'],
        },
        {
          date: '2025-12-03', version: 'v1.0.6', title: '홈 화면 변경 및 UI 개선',
          details: [
            '홈화면에서 미결금, 잔금 데이터를 조회할 수 있습니다.',
            '상단에서 로그인 사용자명을 확인할 수 있습니다.',
          ],
        },
        {
          date: '2025-12-02', version: 'v1.0.5', title: '현장별 매출매입 페이지 추가 및 UI 개선',
          details: [
            '현장별 상세 매출/매입을 조회할 수 있는 페이지가 신설되었습니다.',
            '현장등록 및 거래처등록 페이지의 레이아웃이 변경되었습니다.',
          ],
        },
        {
          date: '2025-11-09', version: 'v1.0.4', title: '로그인 프로세스 안정화',
          details: ['특정 브라우저에서 로그인이 튕기는 오류를 수정했습니다.'],
        },
        {
          date: '2025-11-02', version: 'v1.0.3', title: '입력 편의성 기능 추가',
          details: [
            '기타경비(Y/N) 옵션이 추가되었습니다.',
            '행 추가 시 날짜가 조회 기간에 맞춰 자동 설정됩니다.',
            '세금계산서 입력 시 현장명 검색 기능이 강화되었습니다.',
          ],
        },
  ];

  const VISIBLE_COUNT = 3; // 피드에서는 너무 길면 지루하므로 기본 3개만 표시
  const visibleNotices = showAllNotices ? noticeData : noticeData.slice(0, VISIBLE_COUNT);
  const hiddenCount = noticeData.length - VISIBLE_COUNT;

  // ── 이익 트렌드 아이콘 ────────────────────────────────────
  const ProfitIcon = () => {
    if (profit > 0) return <TrendingUp size={16} strokeWidth={2} aria-hidden="true" />;
    if (profit < 0) return <TrendingDown size={16} strokeWidth={2} aria-hidden="true" />;
    return <Minus size={16} strokeWidth={2} aria-hidden="true" />;
  };

  // 피드 리스트 렌더링 함수
  const renderFeedList = (list, colorClass) => {
    if (list.length === 0) {
      return <div className="feed-empty">해당 내역이 없습니다.</div>;
    }
    return (
      <ul className="feed-list">
        {list.map((item) => (
          <li key={item.COST_ID} className="feed-list-item">
            <div className="feed-list-info">
              <span className="feed-list-name">{item.CUSTOMER_NAME}</span>
              <span className="feed-list-sub">{item.FIELD_NAME} · {item.ISSUED_DATE}</span>
            </div>
            <strong className={`feed-list-amount ${colorClass}`}>
              ₩ {formatNumber(item.REMAIN_AMOUNT)}
            </strong>
          </li>
        ))}
      </ul>
    );
  };

return (
    <div className="feed-root">

      {/* ── 상단 피드 헤더 ── */}
      <header className="feed-main-header">
        <div className="feed-header-left">
          <Calendar size={20} strokeWidth={1.8} className="text-gray-500" />
          <div>
            <h1 className="feed-today">{todayFormatted} ({dayName})</h1>
            <p className="feed-meta">{quarterLabel} · 올해 {dayOfYear}번째 날 · 이번 달 D-{daysLeft}</p>
          </div>
        </div>
        <div className="feed-header-right">
          <div className="progress-wrapper">
            <span className="progress-label">이번달 진행률</span>
            <div className="progress-track">
              <div className="progress-fill" style={{ width: `${monthProgress}%` }} />
            </div>
            <span className="progress-value">{monthProgress}%</span>
          </div>
        </div>
      </header>

      <div className="feed-container">

        {/* ── 좌측 사이드바 (PC: 좌측 고정 / 모바일: 상단) ── */}
        <aside className="feed-sidebar">
          {/* 포스트 1: KPI (재무 요약) */}
          <article className="feed-post">
            <div className="post-header">
              <div className="post-avatar bg-indigo">
                <PieChart size={20} color="white" />
              </div>
              <div className="post-header-text">
                <h2 className="post-author">재무 요약</h2>
                <span className="post-time">{today.getFullYear()}년 기준</span>
              </div>
            </div>
            <div className="post-content">
              <div className="kpi-feed-grid">
                <div className="kpi-feed-item">
                  <span className="kpi-label">누적 매출</span>
                  <strong className="kpi-value text-blue">₩ {formatNumber(outData)}</strong>
                </div>
                <div className="kpi-feed-item">
                  <span className="kpi-label">누적 매입</span>
                  <strong className="kpi-value text-red">₩ {formatNumber(inData)}</strong>
                </div>
                <div className="kpi-feed-item highlight">
                  <span className="kpi-label">총 이익 (이익률 {profitRate}%)</span>
                  <strong className={`kpi-value ${profit >= 0 ? 'text-green' : 'text-red'}`}>
                    <ProfitIcon /> ₩ {formatNumber(profit)}
                  </strong>
                </div>
              </div>
            </div>
          </article>

          {/* 포스트 2: 미결금 알림 */}
          <article className="feed-post">
            <div className="post-header">
              <div className="post-avatar bg-red">
                <AlertCircle size={20} color="white" />
              </div>
              <div className="post-header-text">
                <h2 className="post-author">미결금</h2>
                <span className="post-time">{remainData.length}건의 미결금 내역이 있습니다.</span>
              </div>
            </div>
            <div className="post-content">
              <div className="feed-total-amount text-red">
                <span>총 미결금</span>
                <strong>₩ {formatNumber(remainTotal)}</strong>
              </div>
              {renderFeedList(remainData, 'text-red')}
            </div>
          </article>

          {/* 포스트 3: 잔금 알림 */}
          <article className="feed-post">
            <div className="post-header">
              <div className="post-avatar bg-blue">
                <Wallet size={20} color="white" />
              </div>
              <div className="post-header-text">
                <h2 className="post-author">잔금</h2>
                <span className="post-time">{remainData2.length}건의 잔금 내역이 있습니다.</span>
              </div>
            </div>
            <div className="post-content">
              <div className="feed-total-amount text-blue">
                <span>총 잔금</span>
                <strong>₩ {formatNumber(remainTotal2)}</strong>
              </div>
              {renderFeedList(remainData2, 'text-blue')}
            </div>
          </article>
        </aside>

        {/* ── 우측 메인 피드 (업데이트 타임라인) ── */}
        <main className="feed-main">
          <div className="feed-divider" style={{ marginTop: 0 }}>
            <span>최근 시스템 업데이트</span>
          </div>

          {visibleNotices.map((notice) => (
            <article className="feed-post" key={notice.version}>
              <div className="post-header">
                <div className="post-avatar bg-gray">
                  <Megaphone size={20} color="white" />
                </div>
                <div className="post-header-text">
                  <h2 className="post-author">업데이트 노트 ({notice.version})</h2>
                  <span className="post-time">
                    {notice.date}
                    {isNewNotice(notice.date) && <span className="badge-new">NEW</span>}
                  </span>
                </div>
              </div>
              <div className="post-content">
                <h3 className="notice-title">{notice.title}</h3>
                <ul className="notice-bullets">
                  {notice.details.map((d, i) => (
                    <li key={i}>{d}</li>
                  ))}
                </ul>
              </div>
            </article>
          ))}

          {/* 더보기 버튼 */}
          {hiddenCount > 0 && (
            <button
              type="button"
              className="feed-more-btn"
              onClick={() => setShowAll((v) => !v)}
            >
              {showAllNotices ? '피드 접기' : `이전 업데이트 더보기 (${hiddenCount}건)`}
              <ChevronDown size={16} strokeWidth={2} style={{ transform: showAllNotices ? 'rotate(180deg)' : 'none', transition: '0.2s' }} />
            </button>
          )}
        </main>

      </div>
    </div>
  );
}

export default Home;